<template lang="html">
    <v-toolbar dense>
        <!-- <router-link v-if="homePage" to="/">Home</router-link> -->
        <!-- Iterate under below to represent the categories -->
        <ul class="menu">
            <li v-for="(route, index) in $route.matched" :key='index'>
                <Crumbs :route="route"></Crumbs>
            </li>
        </ul>
    </v-toolbar>
</template>

<script>
import Crumbs from './Crumbs'

export default {
    name: 'Navigation',
    components: {
        Crumbs
    },
    data: () => ({
        // The filterDrawer below is used to launch a modal to filter down contentStream items by product category variables
        // filterDrawer: null
    }),
    computed: {
        checkRoutes() {
            return this.$route.matched
        }

    }
}
</script>

<style lang="css">
.menu {
  list-style-type: none;
}
.menu li {
  display: inline-block;

}
a {
    text-decoration: none;
    margin-left: 5px;
    padding: 5px;
    border: 1px solid black;
    border-radius: 3px;
}

.separator {
  display: inline-block;
}
</style>
